import { MapPinOff } from "lucide-react";

/**
 * MapEmptyState - Displays when map search returns no results
 *
 * @param {Object} props
 * @param {boolean} props.isDark - Whether dark mode is active
 * @param {'centered' | 'banner'} [props.variant='centered'] - Display variant
 *   - centered: Full-height centered layout for desktop list view
 *   - banner: Compact floating banner for mobile carousel
 */
export function MapEmptyState({ isDark, variant = "centered" }) {
  if (variant === "banner") {
    return (
      <div className="px-4 py-3">
        <div
          className={`flex items-center gap-3 px-4 py-3 rounded-2xl shadow-lg ${
            isDark ? "bg-zinc-900/95 text-white" : "bg-white/95 text-black"
          }`}
          style={{ backdropFilter: "blur(8px)" }}
        >
          <MapPinOff
            className={`h-6 w-6 flex-shrink-0 ${isDark ? "text-white/40" : "text-black/40"}`}
            strokeWidth={1.5}
          />
          <div className="flex-1 min-w-0">
            <p className={`text-sm font-medium ${isDark ? "text-white/90" : "text-black/90"}`}>
              Bu alanda ilan bulunamadı
            </p>
            <p className={`text-xs ${isDark ? "text-white/50" : "text-black/50"}`}>
              Haritada farklı bir bölgeye gidin
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Default: centered variant
  return (
    <div
      className={`flex flex-col items-center justify-center h-full px-6 py-12 text-center ${
        isDark ? "text-white/60" : "text-black/60"
      }`}
    >
      <MapPinOff
        className={`h-12 w-12 mb-4 ${isDark ? "text-white/30" : "text-black/30"}`}
        strokeWidth={1.5}
      />
      <p className={`text-base font-medium mb-2 ${isDark ? "text-white/80" : "text-black/80"}`}>
        Bu alanda ilan bulunamadı
      </p>
      <p className="text-sm">Haritada farklı bir bölgeye gidin ve tekrar arayın</p>
    </div>
  );
}

export default MapEmptyState;
